import React, { } from "react";
import { Box, Modal, Paper, Popover } from "@mui/material";

import { CloseIcon } from "../assets/images/icons.jsx";


export default function UniModal({ initElement, children, initElementProps }) {
  const [open, setOpen] = React.useState(false);

  return <React.Fragment>
    <Box onClick={() => setOpen(!open)}
      sx={{
        display: 'flex',
      }}
    >
      {
        initElement && initElement(
          {
            style: { cursor: 'pointer' },
            ...initElementProps
          }
        )
      }
    </Box>
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        display: 'flex',
      }}
      hideBackdrop={false}
    >
      <Paper sx={{
        margin: "auto",
        position: 'relative',
        padding: '32px 32px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: 'min-content',
        "& > .close": {
          position: 'absolute',
          right: 12,
          top: 12,
          height: 24,
          cursor: 'pointer',
        },
      }}>
        <CloseIcon className="close" style={{ color: "#C7CAC8" }} onClick={() => setOpen(false)} />
        {children}
      </Paper>
    </Modal>
  </React.Fragment>

}